import { Component, Input, EventEmitter, Output } from '@angular/core';
import { Match } from '../../models';

@Component({
  selector: 'edit-match-button',
  template: `
    <button mat-fab id="edit-button" matTooltip="Edit Match" [matTooltipPosition]="tooltipPosition" (click)="onEdit(currentMatch)">
        <mat-icon>mode_edit</mat-icon>
    </button>
    `,
  styles: []
})
export class EditMatchButtonComponent {
  @Input() match: Match;
  @Input() tooltipPosition = 'above';
  @Output() edit = new EventEmitter<Match>();

  onEdit(match: Match) {
    this.edit.emit(match);
  }
}
